const root = '/unlock';

export default {
  root,
} as const;
